export enum Messages {
  DirtyCheck = 'Exiting this window will cause any unsaved data to be lost. Are you sure you want to continue?',
  UWReviewRequiredMessage = 'Under Writer review required!. Do you want to proceed with review?',
  SurplusLineHeading = 'Please complete the form fields below',
  DocuSignPopupHeading = 'DocuSign Application',
  SignatureMethodChangeTitle = 'Confirmation',
  SignatureMethodChange = 'Do you want to change signature method?',
  ValidateDocumentMessage = 'Please validate the documents',
  InstallmentBillAgrMessage = '* Please complete the Installment Bill Aggrement found within the Documents Complete section.'
}

export enum Status {
  Success = 'SUCCESS',
  Failure = 'FAILURE',
  PendingReview = 'EHelpUWReview',
  Step4Purchase = 'Step4Purchase',
  EHelpReviewDoc = 'EHelpReviewDoc',
  Bound = 'bound',
  BeforeBinding = 'Before Binding',
  PriorToBind = 'Prior to Bind',
  Incomplete = 'Incomplete',
  Completed = 'Completed',
  PendingReviewMessage = 'Pending Underwriter Review',
  Renewal = 'Renewal',
  RenewalReview = 'RenewalReview',
  PaymentPlan = 'One Invoice',
  Declined = 'Declined',
  DeclinedNewBusiness = 'Declined New Business',
  EnSubmissionType = 'Endorsement',
  EnPolicyStatus = 'EHelpUWReview',
  NotFound = 'NotFound'
}

export enum ButtonType {
  FilloutForm = 'Fill Out Form',
  EditForm = 'Edit Form',
  Continue = 'Continue',
  ReSend = 'Resend',
  Download = 'Download',
  ReDownload = 'Re-Download'
}

export enum BillingType {
  AgencyBill = 'Agency Bill',
  PaperlessPremiumFinancing = 'Paperless Premium Financing',
  InstallmentBill = 'Installment Bill'
}

export enum SummaryUrl {
  General = 'Steps',
  Pollution = 'PLSteps',
  Professional = 'PRSteps',
  BUilders = 'BRSteps',
  Excess = 'EXSteps',
  Contractors = 'CESteps',
  BoundGeneral = 'Bound Policy'
}

export enum InsuredFormType {
  Scheduled = 'Scheduled',
  Blanket = 'Blanket'
}

export enum DesignatedProject {
  Text = 'Designated Project Address',
  Verbiage = 'Any location at which you are performing operations during the policy period and directly related to work performed under a written contract requiring that the person or organization for whom the work is performed be added as an additional insured.'
}

export enum TaxAndFeesType {
  SurplusLinesTax = 'Surplus Lines Tax',
  StampFee = 'As required by written contract',
  Total = 'Total'
}

export enum CECancelEdit {
  Step1A = 1,
  Step1Address,
  Step1AUpdate,
  Step1B,
  Step1BUpdate,
  Step1C,
  Step1CUpdate,
  Step2A,
  Step2AUpdate,
  Step2B
}

export enum FileType {
  PDF = 'pdf',
  XLS = 'xls',
  XLSX = 'xlsx'
}
export enum PageUrl {
  Dashboard = 'dashboard',
  Insured = 'insured',
  Owner = 'owner',
  Artisan = 'artisan',
  Ratings = 'ratings',
  Liability = 'liability',
  ExcessCoverage = 'excesscoverage',
  Property = 'property',
  GeneralQuestion = 'generalquestion',
  CoverageQuestion = 'coveragequestion',
  Document = 'documents',
  RenewalReview = 'renewalreview',
  PolicySnapshot = 'policysnapshot',
  VerifyCoverage = 'verifycoverage',
  VerifyPolicy = 'verifypolicy',
  ActionItems = 'actionitems',
  Coverages = 'coverages',
  Policy = 'policy',
  Jobsite = 'jobsite',
  Additional = 'additionalinfo',
  Automobile = 'automobile',
  Employee = 'employeebenefits',
  Employer = 'employersliability',
  Losspayee = 'losspayee',
  NewsFeed = 'feed',
  BoundPolicy = 'bound',
  EditAddress = 'edit',
  ReviewAddress = 'review',
  PayrollReciept = 'receipt',
  ReviewSubmit = 'submit',
  Classification = 'classification',
  ContactUs = 'us',
  Request = 'access',
  ThankYou = 'you',
  Decline = 'declined',
  Equipment = 'equipment',
  EnPolicy = 'enpolicysnapshot',
  EnCoverage = 'encoverage',
  EnPolicyInfo = 'enpolicyinformation',
  AdInsured = 'adinsured',
  Submit = 'reviewsubmit',
  AddForms = 'addforms'
}

export enum PageTitle {
  Dashboard = 'Dashboard',
  Artisan = 'Dashboard',
  Insured = 'Insured Information',
  Owner = 'Owner Information',
  Ratings = 'Rating Information',
  Liability = 'Liability Coverage',
  ExcessCoverage = 'Excess Coverage',
  Property = 'Personal Property',
  GeneralQuestion = 'General Question',
  CoverageQuestion = 'Coverage Question',
  Document = 'Documents',
  RenewalReview = 'Renewal Review',
  PolicySnapshot = 'Policy Snapshot',
  VerifyCoverage = 'Coverages',
  VerifyPolicy = 'Policy Information',
  ActionItems = 'Purchase Policy',
  Coverages = 'Coverage Summary',
  Policy = 'Policy Summary',
  Jobsite = 'Jobsite Information',
  Additional = 'Additional Information',
  Automobile = 'Automobile',
  Employee = 'Employee Benifits',
  Employer = 'Employers Liability',
  Losspayee = 'Loss Payee/Mortgagee',
  NewsFeed = 'News Feed',
  BoundPolicy = 'Bound Policy',
  EditAddress = 'Address Change',
  ReviewAddress = 'Review Address',
  PayrollReciept = 'Exposure Change',
  ReviewSubmit = 'Review Submit',
  Classification = 'Classification Change',
  ContactUs = 'Contact Us',
  Request = 'Request Access',
  ThankYou = 'Thank You',
  Decline = 'Declined',
  Equipment = 'Equipment Information',
  EnPolicy = 'Pending Review',
  EnCoverage = 'Coverage',
  EnPolicyInfo = 'Policy Information',
  AdInsured = 'Additional Insured',
  Submit = 'Review Submit',
  AddForms = 'Add Forms'
}

export enum LoginScreenType {
  EnrollMFA = 'EnrollMFA',
  EnrollSMS = 'EnrollSMS',
  EnrollSmsCodeSent = 'EnrollSmsCodeSent',
  VerifySms = 'VerifySms',
  VerifyVoiceCall = 'VerifyVoiceCall',
  RecieveACodeSMS = 'RecieveACodeSMS',
  EnrollVoice = 'EnrollVoice',
  EnrollVoiceCallSent = 'EnrollVoiceCallSent'
}
export enum LoginSubScreenType {
  CODESEND = 'CODE-SEND',
  CODESENT = 'CODE-SENT',
  RESET = 'RESET',
  CALL = 'CALL',
  CALLING = 'CALLING',
  REDIAL = 'REDIAL'
}

export enum LoginFormValidation {
  CODE_SENT = 'CODE-SENT',
  INVALID_FORM = 'INVALID-FORM',
  INVALID_REQUEST = 'INVALID-REQUEST',
  SESSION_EXPIRED = 'SESSION-EXPIRED',
  REDIAL = 'REDIAL'
}

export const ActiveSessionTime = 1000 * 60 * 120;
